import React from "react";
import {ResetPasswordRequestFormContainer} from "../../../components/apps/public/reset-password/ResetPasswordRequestForm.container";

export const ResetPasswordRequestPage = () => <ResetPasswordRequestFormContainer/>